

function adjustPLPProdTitle() {
  
  var plpProduct = $('.boost-pfs-filter-product-item');
  
  plpProduct.each(function(){
      var originalPlpProductTitle = $(this).find('.prod__title__attr').attr('data-title');
      var plpProductTitleDiv = $(this).find('.boost-pfs-filter-product-item-title');
      var plpProductTitle = $(this).find('.boost-pfs-filter-product-item-title').text();
      var slicePLPTitle = '';
    
      if ($(window).width() <= 576) {
        slicePLPTitle = plpProductTitle.slice(0, 15);
        plpProductTitleDiv.text(slicePLPTitle);
        plpProductTitleDiv.addClass('extra__dots');
        
      } else if ($(window).width() <= 768) {
        slicePLPTitle = plpProductTitle.slice(0, 35);
        plpProductTitleDiv.text(slicePLPTitle);
        plpProductTitleDiv.addClass('extra__dots');
       
      } else {
        plpProductTitleDiv.text(originalPlpProductTitle);
        plpProductTitleDiv.removeClass('extra__dots');
      }
    
    });
  
}

// function adjustMiniCartProdTitle() {
  
//   var plpProduct = $('.boost-pfs-filter-product-item');
  
//   plpProduct.each(function(){
//       var originalPlpProductTitle = $(this).find('.prod__title__attr').attr('data-title');
//       var plpProductTitleDiv = $(this).find('.boost-pfs-filter-product-item-title');
//       var plpProductTitle = $(this).find('.boost-pfs-filter-product-item-title').text();
//       var slicePLPTitle = '';
    
// //       console.log('og title is ' + originalPlpProductTitle);
    
//       if ($(window).width() <= 576) {
// // 		console.log('were on mobile');
        
//         slicePLPTitle = plpProductTitle.slice(0, 15);
//         plpProductTitleDiv.text(slicePLPTitle);
//         plpProductTitleDiv.addClass('extra__dots');
        
//       } else if ($(window).width() <= 768) {
// //         console.log('were on tablet');
        
//         slicePLPTitle = plpProductTitle.slice(0, 35);
//         plpProductTitleDiv.text(slicePLPTitle);
//         plpProductTitleDiv.addClass('extra__dots');
       
//       } else {
// //         console.log('were on desktop - set og title');
//         plpProductTitleDiv.text(originalPlpProductTitle);
//         plpProductTitleDiv.removeClass('extra__dots');
//       }
    
      
      
//     });
  
// }